export default __webpack_public_path__ + "static/media/s3.ef224223.PNG";